module.exports = __webpack_public_path__ + "static/startupSpecialist-4f5cb541cc66edc9ad67f059721d6d18.png";